import { useQuery } from '@tanstack/react-query';
import { PaidOrderService } from 'modules/sales/paid-order/services';
import { PAID_ORDERS_ONE_KEY } from 'modules/sales/paid-order/constants';
import { useCallback } from 'react';
import { IOrder } from 'modules/sales/common/interfaces/IOrder';
import { useParams } from 'react-router';

export const useFindOneOrderByClient = (orderId: string | null) => {
  const { id: clientId } = useParams();

  const fetch = useCallback(
    () => PaidOrderService.getOneOrderByClient(clientId as string, orderId as string),
    [clientId, orderId],
  );
  return useQuery<IOrder>([orderId, PAID_ORDERS_ONE_KEY], fetch, { enabled: !!orderId && !!clientId });
};
